// extracted by mini-css-extract-plugin
export default {"container":"UnsupportedDevice_container__knZ3o"};